module.exports = __webpack_public_path__ + "img/login-user-bg.a9cc7af8.png";